import * as Yup from 'yup';

export default Yup.object().shape({
  maxAcceptanceDate: Yup
    .date()
    .required()
    .min(new Date(), 'La data di delibera deve essere nel futuro'),
});
